export const experience = [
    {
        id: 0,
        company: "DomApp",
        role: 'Frontend Developer',
        period: '2026 - Present',
        description: [
            'Building performant, scalable interfaces with Next.js and Tailwind CSS following clean frontend architecture principles.',
            'Applying design patterns to structure maintainable, reusable component systems.',
            'Integrating Three.js to deliver interactive 3D experiences within web applications.'
        ],
        tech: ['Next.js', 'Tailwind CSS', 'Git', 'Three.js', 'Design Patterns', 'Frontend Archticture']
    },
    {
        id: 1,
        company: "Adam's_Agency",
        role: 'Full Stack Developer',
        period: '2025 - 2026',
        description: [
            'Led development of scalable cloud-native web applications using React and Node.js.',
            'Developed responsive and functional web applications for branch initiatives',
            'Collaborated with designers to implement pixel-perfect UI components.'
        ],
        tech: ['React', 'Node.js', 'AWS', 'express.js', 'MongoDB', 'Tailwind CSS', 'Git']
    },
    {
        id: 2,
        company: 'IEEE_KSB_branch',
        role: 'Head of Frontend Committee',
        period: '2025 - 2026',
        description: [
            'Led and coordinated frontend development projects within the team.',
            'Mentored team members on React and best practices for web development.',
            'Developed responsive and functional web applications for branch initiatives'
        ],
        tech: ['HTML', 'CSS', 'JS', 'React']
    },
    {
        id: 3,
        company: 'IEEE_KSB_branch',
        role: 'Vice Head of Frontend Committee',
        period: '2024 - 2025',
        description: [
            'Led and coordinated frontend development projects within the team.',
            'Mentored team members on React and best practices for web development.',
            'Organized and facilitated regular code reviews and knowledge sharing sessions.'
        ],
        tech: ['HTML', 'CSS', 'JS', 'React']
    }
];
